import React from 'react';
import { connect } from 'react-redux';
import { updateHttpStatus as dispatchUpdateHttpStatus } from '../../actions/httpStatus';
import NotFound from './NotFound';

const NOT_FOUND_HTTP_STATUS = 404;

type NotFoundContainerProps = {
    shouldDispatchHttpStatus: boolean;
    updateHttpStatus: () => void;
};

class NotFoundContainer extends React.Component<NotFoundContainerProps> {
    constructor(props) {
        super(props);

        const { shouldDispatchHttpStatus, updateHttpStatus } = this.props;

        // this will for now only be used by Contento views
        if (shouldDispatchHttpStatus) {
            updateHttpStatus();
        }
    }

    render() {
        return <NotFound />;
    }
}

const mapDispatchToProps = (dispatch) => ({
    updateHttpStatus: () => dispatch(dispatchUpdateHttpStatus(NOT_FOUND_HTTP_STATUS)),
});

export default connect(null, mapDispatchToProps)(NotFoundContainer);
